const ordersTypes = {
  SAVE_ORDER_HISTORY_START: 'SAVE_ORDER_HISTORY_START',
  GET_USER_ORDER_HISTORY_START: 'GET_USER_ORDER_HISTORY_START',
  SET_USER_ORDER_HISOTRY: 'SET_USER_ORDER_HISOTRY',
  GET_ORDER_DETAILS_START: 'GET_ORDER_DETAILS_START',
  SET_ORDER_DETAILS: 'SET_ORDER_DETAILS'
};

export default ordersTypes;